// Simple Moroccan phone validation
export const isValidPhoneNumber = (phone: string) => {
  const phoneRegex = /^(\+212|0)([5-7])\d{8}$/;
  return phoneRegex.test(phone?.trim());
};


// Massar codes: 10 alphanumeric characters, usually starts with a letter
export const isValidMassarCode = (code: string) => {
  const massarRegex = /^[A-Z][0-9]{9}$/i;
  return massarRegex.test(code?.trim());
};

export const isValidCIN = (cin: string): boolean => {
  if (!cin) return false;
  const cleanedCIN = cin.trim().toUpperCase();
  const cinRegex = /^[A-Z]{1,2}\d{6}$/;
  if (!cinRegex.test(cleanedCIN)) {
    return false;
  }
  return true;
};


export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};